<template>
	<div id="categoria-page">
		<div class="categoria-header">
			<div class="categoria-header-background blurry" :style="'background-image: url(https://lineup-bucket-s3.s3.us-east-1.amazonaws.com/categorias/CategoriaOtros.jpg);'"></div>
			<div class="container">
				<div class="categoria-header-content-left" v-if="!isCargandoEventos">
					<div class="breadcrumb">
						<router-link :to="{ name: 'home' }" class="breadcrumb-item">Inicio</router-link>
						<div class="breadcrumb-item">&#8594;</div>
						<router-link :to="{ name: 'eventos' }" class="breadcrumb-item">Eventos</router-link>
						<div class="breadcrumb-item">&#8594;</div>
						<div class="breadcrumb-item">Otros</div>
					</div>
					<h1>Otros</h1>
					<h4>Disfrutá de los mejores eventos</h4>
					<div class="divider"></div>
					<button @click.prevent="$refs['eventos'].scrollIntoView({ behavior: 'smooth' })">
						Ver eventos
					</button>
				</div>
				<div class="categoria-header-content-right">
					<img src="../../assets/ticketin/Otros.svg" alt="">
				</div>
			</div>
		</div>
		<div class="categoria-main" ref="eventos">
			<div class="container">
				<div class="eventos-row" v-if="isCargandoEventos && eventos.length <= 0">
					<SkeletonEventoCard class="evento" v-for="eve in 4" :key="eve" :isDarkMode="false" />
				</div>
				<div class="eventos-row" v-else-if="eventos.length > 0">
					<EventCardAux v-for="eve in eventos" :evento="eve" :key="eve.Evento.EventoId" @click="irAEvento(eve.Evento.EventoId, eve.Evento.EventoSlug)" />
				</div>
				<div class="no-events-found" v-else>
					<i class='bx bx-dizzy' ></i>
					No se encontraron eventos para la categoría
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import EventCardAux from "../../components/eventos/EventCardAux.vue";
	import SkeletonEventoCard from "../../components/skeletons/SkeletonEventoCard.vue";

	export default {
		data(){
			return{
				isCargandoEventos: true,
				eventos: [],
			}
		},
		components: {
			EventCardAux,
			SkeletonEventoCard
		},
		metaInfo: {
			title: 'Otros eventos',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		async mounted() {
			await this.getEventos();
		},
		methods: {
			irAEvento(id, slug) {
				this.$router.push({ name: 'evento', params: { eventSlug: slug, eventId: id } });
			},
			async getEventos(){
				try {
					this.isCargandoEventos = true

					let response = await axios.post('/WSEventosCategoria', {
						EventoCategoriaId: 4,
						Pag: 1,
						Limit: 100,
						IsDesdeRedpagos: false
					});

					if(response.data.ErrorCod === 0){
						this.eventos = response.data.SDTEventos
					}
				} catch (error) {
					console.log('Ocurrió un error al cargar los eventos');
				} finally {
					this.isCargandoEventos = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/_categorias.scss"
</style>